export default "__VITE_ASSET__BAlL1E93__"